!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js"));else if ("function" == typeof define && define.amd) define(["react", "classnames", "@material/react-ripple/dist/index.js"], t);else {
    var r = "object" == typeof exports ? t(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js")) : t(e.react, e.classnames, e["@material/react-ripple/dist/index.js"]);
    for (var n in r) ("object" == typeof exports ? exports : e)[n] = r[n];
  }
}("undefined" != typeof self ? self : this, function (e, t, r) {
  return function (e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var a = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
    }
    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var a in e) r.d(n, a, function (t) {
        return e[t];
      }.bind(null, a));
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 47);
  }({
    0: function _(t, r) {
      t.exports = e;
    },
    1: function _(e, r) {
      e.exports = t;
    },
    18: function _(e, t, r) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      t.CSS_CLASSES = {
        ROOT: "mdc-card",
        OUTLINED: "mdc-card--outlined",
        PRIMARY_ACTION: "mdc-card__primary-action",
        MEDIA: "mdc-card__media",
        MEDIA_SQUARE: "mdc-card__media--square",
        MEDIA_16_9: "mdc-card__media--16-9",
        MEDIA_CONTENT: "mdc-card__media-content",
        ACTIONS: "mdc-card__actions",
        ACTIONS_FULL_BLEED: "mdc-card__actions--full-bleed",
        ACTION_BUTTONS: "mdc-card__action-buttons",
        ACTION_ICONS: "mdc-card__action-icons",
        ACTION: "mdc-card__action",
        ACTION_BUTTON: "mdc-card__action--button",
        ACTION_ICON: "mdc-card__action--icon"
      };
    },
    47: function _(e, t, r) {
      "use strict";

      var n = this && this.__assign || function () {
          return (n = Object.assign || function (e) {
            for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
            return e;
          }).apply(this, arguments);
        },
        a = this && this.__rest || function (e, t) {
          var r = {};
          for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var a = 0;
            for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
          }
          return r;
        },
        o = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = o(r(0)),
        l = o(r(1)),
        c = o(r(48));
      t.CardActionButtons = c.default;
      var s = o(r(49));
      t.CardActionIcons = s.default;
      var u = o(r(50));
      t.CardActions = u.default;
      var f = o(r(51));
      t.CardPrimaryContent = f.default;
      var d = o(r(52));
      t.CardMedia = d.default;
      var p = r(18);
      t.default = function (e) {
        var t,
          r = e.children,
          o = e.className,
          c = void 0 === o ? "" : o,
          s = e.outlined,
          u = void 0 !== s && s,
          f = a(e, ["children", "className", "outlined"]),
          d = l.default(p.CSS_CLASSES.ROOT, c, ((t = {})[p.CSS_CLASSES.OUTLINED] = u, t));
        return i.default.createElement("div", n({
          className: d
        }, f), r);
      };
    },
    48: function _(e, t, r) {
      "use strict";

      var n = this && this.__assign || function () {
          return (n = Object.assign || function (e) {
            for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
            return e;
          }).apply(this, arguments);
        },
        a = this && this.__rest || function (e, t) {
          var r = {};
          for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var a = 0;
            for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
          }
          return r;
        },
        o = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = o(r(0)),
        l = o(r(1)),
        c = r(18);
      t.default = function (e) {
        var t = e.className,
          r = void 0 === t ? "" : t,
          o = e.children,
          s = a(e, ["className", "children"]),
          u = l.default(c.CSS_CLASSES.ACTION_BUTTONS, r);
        return o ? i.default.createElement("div", n({
          className: u
        }, s), function (e) {
          return i.default.Children.map(e, function (e) {
            var t = l.default(e.props.className, c.CSS_CLASSES.ACTION, c.CSS_CLASSES.ACTION_BUTTON),
              r = Object.assign({}, e.props, {
                className: t
              });
            return i.default.cloneElement(e, r);
          });
        }(o)) : null;
      };
    },
    49: function _(e, t, r) {
      "use strict";

      var n = this && this.__assign || function () {
          return (n = Object.assign || function (e) {
            for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
            return e;
          }).apply(this, arguments);
        },
        a = this && this.__rest || function (e, t) {
          var r = {};
          for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var a = 0;
            for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
          }
          return r;
        },
        o = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = o(r(0)),
        l = o(r(1)),
        c = r(18);
      t.default = function (e) {
        var t = e.className,
          r = void 0 === t ? "" : t,
          o = e.children,
          s = a(e, ["className", "children"]),
          u = l.default(c.CSS_CLASSES.ACTION_ICONS, r);
        return o ? i.default.createElement("div", n({
          className: u
        }, s), function (e) {
          return i.default.Children.map(e, function (e) {
            var t = l.default(e.props.className, c.CSS_CLASSES.ACTION, c.CSS_CLASSES.ACTION_ICON),
              r = Object.assign({}, e.props, {
                className: t
              });
            return i.default.cloneElement(e, r);
          });
        }(o)) : null;
      };
    },
    5: function _(e, t) {
      e.exports = r;
    },
    50: function _(e, t, r) {
      "use strict";

      var n = this && this.__assign || function () {
          return (n = Object.assign || function (e) {
            for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
            return e;
          }).apply(this, arguments);
        },
        a = this && this.__rest || function (e, t) {
          var r = {};
          for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var a = 0;
            for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
          }
          return r;
        },
        o = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = o(r(0)),
        l = o(r(1)),
        c = r(18);
      t.default = function (e) {
        var t,
          r = e.className,
          o = void 0 === r ? "" : r,
          s = e.children,
          u = e.fullBleed,
          f = void 0 !== u && u,
          d = a(e, ["className", "children", "fullBleed"]),
          p = l.default(c.CSS_CLASSES.ACTIONS, o, ((t = {})[c.CSS_CLASSES.ACTIONS_FULL_BLEED] = f, t));
        return i.default.createElement("div", n({
          className: p
        }, d), s);
      };
    },
    51: function _(e, t, r) {
      "use strict";

      var n = this && this.__assign || function () {
          return (n = Object.assign || function (e) {
            for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
            return e;
          }).apply(this, arguments);
        },
        a = this && this.__rest || function (e, t) {
          var r = {};
          for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var a = 0;
            for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
          }
          return r;
        },
        o = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = o(r(0)),
        l = o(r(1)),
        c = r(5),
        s = r(18);
      t.PrimaryContentBase = function (e) {
        var t = e.className,
          r = void 0 === t ? "" : t,
          o = e.initRipple,
          c = e.children,
          u = (e.unbounded, a(e, ["className", "initRipple", "children", "unbounded"])),
          f = l.default(s.CSS_CLASSES.PRIMARY_ACTION, r);
        return i.default.createElement("div", n({
          className: f,
          ref: o
        }, u), c);
      }, t.default = c.withRipple(t.PrimaryContentBase);
    },
    52: function _(e, t, r) {
      "use strict";

      var n = this && this.__assign || function () {
          return (n = Object.assign || function (e) {
            for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
            return e;
          }).apply(this, arguments);
        },
        a = this && this.__rest || function (e, t) {
          var r = {};
          for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var a = 0;
            for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
          }
          return r;
        },
        o = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = o(r(0)),
        l = o(r(1)),
        c = r(18),
        s = function s(e) {
          var t = e.imageUrl,
            r = e.style;
          return Object.assign({}, {
            backgroundImage: "url(" + t + ")"
          }, r);
        };
      t.default = function (e) {
        var t,
          r = e.className,
          o = void 0 === r ? "" : r,
          u = e.contentClassName,
          f = void 0 === u ? "" : u,
          d = e.children,
          p = e.square,
          _ = void 0 !== p && p,
          O = e.wide,
          S = void 0 !== O && O,
          m = e.imageUrl,
          y = void 0 === m ? "" : m,
          v = e.style,
          b = void 0 === v ? {} : v,
          h = a(e, ["className", "contentClassName", "children", "square", "wide", "imageUrl", "style"]),
          C = l.default(c.CSS_CLASSES.MEDIA, o, ((t = {})[c.CSS_CLASSES.MEDIA_SQUARE] = _, t[c.CSS_CLASSES.MEDIA_16_9] = S, t));
        return i.default.createElement("div", n({
          className: C,
          style: s({
            imageUrl: y,
            style: b
          })
        }, h), function (e) {
          var t = e.children,
            r = e.contentClassName;
          if (t) {
            var n = l.default(c.CSS_CLASSES.MEDIA_CONTENT, r);
            return i.default.createElement("div", {
              className: n
            }, t);
          }
        }({
          children: d,
          contentClassName: f
        }));
      };
    }
  });
});